import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const HomePage = () => {
  
  return (
    <div className="container mx-auto px-4 py-12">
      
      {/* HERO */}
      <section className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
          Bine ați venit la <span className="text-blue-600">Artisan Stoma Oradea</span>
        </h1>

        <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto mb-8">
          <p>
Artisan Stoma este un cabinet stomatologic modern din Oradea, 
specializat în tratamente dentare complete: implant dentar, ortodonție, estetică dentară, detartraj și tratamente de canal. Oferim servicii stomatologice de calitate pentru copii și adulți.
</p>

        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
          <Link
            to="/appointment"
            className="bg-blue-600 text-white px-8 py-3 rounded-xl font-semibold hover:bg-blue-700 transition"
          >
            Programează-te
          </Link>

          <Link
            to="/services"
            className="border border-blue-600 text-blue-600 px-8 py-3 rounded-xl font-semibold hover:bg-blue-50 transition"
          >
            Vezi serviciile
          </Link>
        </div>

        {/* SOCIAL MEDIA BUTTONS */}
        <div className="flex justify-center gap-6 mb-16">
          
          {/* Instagram */}
<a
  href={
    isMobile()
      ? "instagram://user?username=artisanstoma"
      : "https://www.instagram.com/artisanstoma/"
  }
  target="_blank"
  rel="noopener noreferrer"
  className="w-14 h-14 bg-white shadow-lg rounded-full flex items-center justify-center hover:scale-110 transition"
>


            <svg xmlns="http://www.w3.org/2000/svg" 
              fill="none" viewBox="0 0 24 24" strokeWidth="1.5" 
              stroke="currentColor" className="w-7 h-7 text-pink-600">
              <path strokeLinecap="round" strokeLinejoin="round" 
                d="M15.75 3h-7.5A5.25 5.25 0 003 8.25v7.5A5.25 5.25 0 008.25 21h7.5A5.25 5.25 0 0021 15.75v-7.5A5.25 5.25 0 0015.75 3z" />
              <path strokeLinecap="round" strokeLinejoin="round" 
                d="M12 8.25a3.75 3.75 0 110 7.5 3.75 3.75 0 010-7.5z" />
              <circle cx="16.5" cy="7.5" r="1.125" fill="currentColor" />
            </svg>
          </a>

          {/* Facebook */}
<a
  href={
    isMobile()
      ? "fb://facewebmodal/f?href=https://www.facebook.com/artisanstoma"
      : "https://www.facebook.com/artisanstoma"
  }
  target="_blank"
  rel="noopener noreferrer"
  className="w-14 h-14 bg-white shadow-lg rounded-full flex items-center justify-center hover:scale-110 transition"
>
  <svg xmlns="http://www.w3.org/2000/svg" 
    fill="currentColor" viewBox="0 0 24 24" 
    className="w-7 h-7 text-blue-600">
    <path 
      d="M22 12a10 10 0 1 0-11.5 9.9v-7H8v-3h2.5V9.5a3.5 3.5 0 0 1 3.7-3.9c1 0 2 .1 2 .1v2.3h-1.1c-1.1 0-1.5.7-1.5 1.4V12H18l-.5 3h-2.7v7A10 10 0 0 0 22 12z"
    />
  </svg>
</a>

{/* TikTok
<a
  href="https://www.tiktok.com/@popadela615?is_copy_url=1&is_from_webapp=v1"
  target="_blank"
  rel="noopener noreferrer"
  className="w-14 h-14 bg-white shadow-lg rounded-full flex items-center justify-center hover:scale-110 transition"
>
  <svg xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" fill="currentColor" 
    className="w-7 h-7 text-black">
    <path d="M20 8.6c-1.6-.1-3.1-.7-4.2-1.8-1-1-1.4-2.2-1.5-3.4V3h-3.1v12.3c-.1 1-.9 1.9-2 2.1-1.3.3-2.6-.6-2.8-1.9-.3-1.3.6-2.6 1.9-2.8.3-.1.6-.1.9 0V9.6c-2.9-.3-5.6 1.8-5.9 4.7s1.8 5.6 4.7 5.9 5.6-1.8 5.9-4.7c0-.3.1-.6 0 -.9v-6c1.2 1.2 2.9 2 4.7 2.1V8.6z"/>
  </svg>
</a>*/}



        </div>
      </section>

      {/* Restul paginii (BENEFICII, DESPRE NOI etc.) */}


      {/* BENEFICII */}
      <section className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
        
        <div className="bg-blue-50 p-8 rounded-2xl text-center shadow-sm hover:shadow-md transition">
          <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-5">
            <svg className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>

          <h3 className="text-xl font-bold text-gray-800 mb-3">
            Servicii de Calitate
          </h3>
          <p className="text-gray-600">
            Tratamente stomatologice moderne realizate cu grijă și profesionalism.
          </p>
        </div>

        <div className="bg-green-50 p-8 rounded-2xl text-center shadow-sm hover:shadow-md transition">
          <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-5">
            <svg className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          <h3 className="text-xl font-bold text-gray-800 mb-3">
            Programare Rapidă
          </h3>
          <p className="text-gray-600">
            Programări rapide și flexibile, adaptate programului dumneavoastră.
          </p>
        </div>

        <div className="bg-purple-50 p-8 rounded-2xl text-center shadow-sm hover:shadow-md transition">
          <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-5">
            <svg className="h-8 w-8 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318 1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>
          </div>

          <h3 className="text-xl font-bold text-gray-800 mb-3">
            Confort & Siguranță
          </h3>
          <p className="text-gray-600">
            Un mediu relaxant, sigur și adaptat tuturor pacienților.
          </p>
        </div>
      </section>

      {/* DESPRE NOI */}
      <section className="
    bg-white/80
    backdrop-blur
    p-8
    rounded-2xl
    shadow-lg
    border
    border-gray-200
  ">
        <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
          Despre Noi
        </h2>

        <p className="text-gray-600 mb-4 text-center">
          Artisan Stoma este un cabinet stomatologic modern, dotat cu echipamente
          de ultimă generație și o echipă dedicată sănătății dumneavoastră.
        </p>

        <p className="text-gray-600 text-center">
          Cu peste <span className="font-semibold text-gray-800">25 de ani de experiență</span>,
          punem accent pe calitate, empatie și rezultate durabile.
        </p>



      </section>


  {/* CARUSEL REZENTII GOOGLE */}
      <section className="mt-20">
        <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
          Ce spun pacienții noștri
        </h2>

        <CarouselReviews />
      </section>
    </div>
    
  );
};

const CarouselReviews = () => {
  const reviews = [
    {
      text: "Va mulțumesc mult ca m-ati luat asa repede si mi-ati rezolvat durerea de la maseaua de minte. Recomand 100%",
      author: "Ionut Fechete",
    },
    {
      text: "Recomand cu incredere.",
      author: "Cristea Raul",
    },
    {
      text: "Recomand",
      author: "Nicu",
    },
      {
      text: "M-au programat rapid si mi-au rezolvat problema. Recomand!",
      author: "Razvan",
      },
    {
      text: "Profesionalism",
      author: "George",
    },
      {
      text: "Servicii de calitate",
      author: "Ligia",
      },
  ];

  const doubled = [...reviews, ...reviews]; // 🔥 SECRETUL

  const [index, setIndex] = useState(0);
  const [transition, setTransition] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
      setTransition(true);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // când am ajuns la jumătate, resetăm instant fără animație
    if (index === reviews.length) {
      setTimeout(() => {
        setTransition(false);
        setIndex(0);
      }, 700); // timpul animatiei
    }
  }, [index, reviews.length]);

  return (
    <div className="relative w-full max-w-4xl mx-auto overflow-hidden">
      <div
        className="flex"
        style={{
          transform: `translateX(-${index * 100}%)`,
          transition: transition ? "transform 0.7s ease" : "none",
        }}
      >
        {doubled.map((rev, i) => (
          <div key={i} className="w-full flex-shrink-0 px-6">
            <div className="bg-blue-50 p-8 rounded-2xl shadow-md text-center">
              <p className="text-gray-700 italic mb-4">“{rev.text}”</p>
              <h3 className="font-semibold text-gray-800">
                ⭐️⭐️⭐️⭐️⭐️ {rev.author}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};


export default HomePage;
